
import React from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';


const Navigation = () => {
    return (
        <Navbar collapseOnSelect expand="lg" variant="dark">
            <Container>
                <Navbar.Brand style={{ color: '#ccd6f6 ', fontSize: '20px', marginLeft: '20px' }} href="/home">AKHI</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse className="justify-content-end text-light">
                    {/* <Nav.Link style={{ color: '#ccd6f6 ', fontSize: '20px', }} as={Link} to="/home"> Home</Nav.Link> */}
                    <Nav.Link style={{ color: '#ccd6f6 ', fontSize: '20px', }} as={HashLink} to="/home#home-about"> About</Nav.Link>
                    <Nav.Link style={{ color: '#ccd6f6 ', fontSize: '20px', }} as={Link} to="/allProjects"> Projects</Nav.Link>
                    <Nav.Link style={{ color: '#ccd6f6 ', fontSize: '20px', }} as={HashLink} to="/home#blogs"> Blogs</Nav.Link>
                    <Nav.Link style={{ color: '#ccd6f6 ', fontSize: '20px', }} as={HashLink} to="/home#contact"> Contact</Nav.Link>
                    <a target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1RFlQw-STwl_-kmX-l4erWyrevsTL6FQN/view?usp=sharing">
                        <Button style={{ fontSize: '20px', }} variant="outline-success">Resume</Button>{' '} </a>
                </Navbar.Collapse>
            </Container>
        </Navbar >
    );
};

export default Navigation;